import { number, object, string } from 'yup';

export const createOperatorSchema = object().shape({
    firstName: string().min(3).required(),
    lastName: string().min(3).required(),
    documentType: string().oneOf(['V', 'E', 'P']).required(),
    document: string().min(6).max(10).required(),
    code: string().min(1).optional(),
    email: string().email().required(),
    password: string().min(8).required(),
    roleId: number().min(1).required(),
});
